module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Estimulacion RO.4f3b50c3.png";